"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Screen = require("../layout/Screen/Screen.styled");

var _SlidingModal = require("./SlidingModal.styled");

var _SlidingTransition = _interopRequireDefault(require("./SlidingTransition.styled"));

var _utils = require("../utils");

var _utilities = require("../GlobalStyle/utilities/utilities.styled");

var _componentAnalytics = require("../Components/ComponentAnalytics/componentAnalytics");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SlidingModal = function SlidingModal(_ref) {
  var children = _ref.children,
      open = _ref.open,
      onClose = _ref.onClose;
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("SlidingModal");
  }, []);

  var _useState = (0, _react.useState)("slidein"),
      currentAnimation = _useState[0],
      setCurrentAnimation = _useState[1];

  var _useState2 = (0, _react.useState)("slidein"),
      nextAnimation = _useState2[0],
      setNextAnimation = _useState2[1];

  var closeRef = (0, _react.useRef)(null);
  var modalRef = (0, _react.useRef)(null);

  var handleAnimationEnd = function handleAnimationEnd(animationName) {
    if ("slidein" === animationName) {
      setNextAnimation("slideout");
    } else {
      setNextAnimation("slidein");
      setCurrentAnimation("slidein");
    }
  };

  var keyListenersMap = new Map([[27, function onEscClose() {
    onClose();
  }], [9, function handleTabKey(e) {
    var focusableElems = (0, _utils.getFocusableElement)(modalRef.current);
    (0, _utils.trapTabKey)(e, focusableElems);
  }]]);
  (0, _react.useEffect)(function () {
    var keyListener = function keyListener(e) {
      var listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    };

    if (open) {
      closeRef.current.focus();
      document.addEventListener("keydown", keyListener);
    } else {
      setCurrentAnimation(nextAnimation);
      document.removeEventListener("keydown", keyListener);
    } // check this is removed even without the return


    return function () {
      return document.removeEventListener("keydown", keyListener);
    };
  }, [open]); // eslint-disable-line

  if (!(open || "slideout" === currentAnimation)) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Screen.FullScreenOpac, {
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_SlidingTransition.default, {
    role: "dialog",
    "aria-modal": "true",
    animation: currentAnimation,
    ref: modalRef,
    onAnimationEnd: function onAnimationEnd(event) {
      return handleAnimationEnd(event.animationName);
    }
  }, /*#__PURE__*/_react.default.createElement(_SlidingModal.StyledSlidingModal, null, /*#__PURE__*/_react.default.createElement(_SlidingModal.StyledSlidingModal.DismissButton, {
    onClick: onClose,
    "data-test": "modal-close-button",
    ref: closeRef
  }, /*#__PURE__*/_react.default.createElement(_SlidingModal.StyledSlidingModal.CloseIcon, null), /*#__PURE__*/_react.default.createElement(_utilities.SROnly, null, "Close")), children)));
};

SlidingModal.propTypes = {
  open: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  children: _propTypes.default.node
};
var _default = SlidingModal;
exports.default = _default;